<template>
  <v-dialog v-model="dialog" max-width="450">
    <template v-slot:activator="{ on, attrs }">
      <v-btn small v-bind="attrs">
        <v-icon v-bind="attrs" v-on="on">mdi-forum</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-toolbar dense>
        <v-toolbar-title>{{ $t("reasonFroCancellation") }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text class="text-center">
        <div class="ml-4 pt-3 text-left">
          <div class="pb-1">{{ $t("user") }}: {{ item.name_player }}</div>
          <div>
            {{ $t("dateTime") }}:
            {{ item.register_date }}
          </div>
          <div class="pb-1">
            {{ $t("value") }}: {{ $t("labelCurrency") }}
            {{ item.value_requested }}
          </div>
          <div class="pb-1">
            {{ $t("reason") }}:
            {{ item.error_gateway }}
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["item"],
  data: () => ({
    dialog: false,
    withdraw_id: "",
  }),
  computed: {
    message() {
      return this.$t("confirmWithdrawalAuthorization");
    },
    dialogTitle() {
      return this.$t("authorizeWithdrawal");
    },
  },
  methods: {
    authorizeCashout() {
      const body = {
        withdraw_id: this.id_withdraw,
      };
      this.$request
        .post("/colab/bankOnline/authorizeCashout", body)
        .then((response) => {
          if (response.length == 0) return;
          this.$store.commit("setFeedbackSnack", {
            msg: response.messages,
            color: "success",
          });
          this.dialog = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  filters: {
    handleEntrys: function(value) {
      value = value * -1;
      return value;
    },
  },
};
</script>
